import { EscrowAccountContent } from './EscrowAccountContent';

export default EscrowAccountContent;
